module.exports = __webpack_public_path__ + "static/media/FirmaDigitalMaveETT.747f5d1e.msi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FirmaDigitalMaveETT.msi
// module id = 874
// module chunks = 0